import { render, staticRenderFns } from "./BridgePermitRatingsView.vue?vue&type=template&id=4741dd88"
import script from "./BridgePermitRatingsView.vue?vue&type=script&lang=ts"
export * from "./BridgePermitRatingsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports